import wx from 'weixin-js-sdk'
import request from '@/utils/request'

var ua = navigator.userAgent.toLocaleLowerCase()

/**
 * const url = curHref.split('#')[0]
 * @param {Object} params = { url: url }
 *
 */
export const initConfig = params => {
  if (!/micromessenger/i.test(ua)) return
  return request({
    method: 'get',
    url: '/wechat/getConfig',
    params
  })
}

/**
 *
 * @param {*} timeStamp
 * @param {*} nonceStr
 * @param {*} packages
 * @param {*} signType
 * @param {*} paySign
 * @returns
 */
export const chooseWXPay = (timeStamp, nonceStr, packages, signType, paySign, appId) => {
  if (!/micromessenger/i.test(ua)) return
  return new Promise((resolve, reject) => {
    wx.ready(() => {
      wx.chooseWXPay({
        appId: appId,
        // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        timestamp: timeStamp,
        // 支付签名随机串，不长于 32 位
        nonceStr: nonceStr,
        // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        package: packages,
        // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        signType: signType,
        // 支付签名
        paySign: paySign,
        success: function (res) {
          resolve(res)
        },
        cancel: function (res) {
          reject(res)
        },
        fail: function (res) {
          reject(res)
        }
      })
    })
  })
}

export const share = (title = '', desc = '', imgUrl = '', url = '') => {
  if (!/micromessenger/i.test(navigator.userAgent)) return
  // 默认分享链接，比如说应用首页
  let shareUrl = location.href
  if (url !== null && url !== '') {
    shareUrl = url
  }
  let shareTitle = '加入我们'
  if (title !== null && title !== '') {
    shareTitle = title
  }
  let shareDesc = '扫码加入'
  if (desc !== null && desc !== '') {
    shareDesc = desc
  }
  let shareImg = location.origin + '../assets/control-1.png'
  if (imgUrl !== null && imgUrl !== '') {
    shareImg = imgUrl
  }
  // wx.config({
  //   debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
  //   appId: res.appId, // 必填，公众号的唯一标识
  //   nonceStr: res.nonceStr, // 必填，生成签名的随机串
  //   signature: res.signature, // 必填，签名，见附录1
  //   timestamp: res.timestamp, // 必填，生成签名的时间戳
  //   jsApiList: [
  //     'chooseWXPay' 支付
  //     'updateAppMessageShareData' 分享朋友
  //     'updateTimelineShareData' 分享朋友圈
  //   ]
  // })
  return new Promise((resolve, reject) => {
    wx.ready(() => {
      // 如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行
      wx.updateAppMessageShareData({
        title: shareTitle, // 分享标题
        desc: shareDesc, // 分享描述
        link: shareUrl, // 分享链接 默认以当前链接
        imgUrl: shareImg, // 分享图标
        success: () => {
          // 分享成功回调，分享成功后要做的事情可以写在这里，比如说上传分享成功信息给服务器，方便做统计
        }
      })
      // 分享朋友圈
      wx.updateTimelineShareData({
        title: shareTitle, // 分享标题
        link: shareUrl, // 分享链接 默认以当前链接
        imgUrl: shareImg, // 分享图标
        success: () => {
          // 分享成功回调，分享成功后要做的事情可以写在这里，比如说上传分享成功信息给服务器，方便做统计
        }
      })
      wx.error(res => {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，
        // 具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        console.log(res)
      })
    })
  })
}
